var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 4.6457L13.691 8.00352C13.8879 8.20039 14 8.47109 14 8.75C14 9.02891 13.8879 9.29961 13.691 9.49648L10.3332 12.8543C10.1582 13.0293 9.92305 13.125 9.67695 13.125C9.16562 13.125 8.75 12.7094 8.75 12.198V10.5H5.25C4.76602 10.5 4.375 10.109 4.375 9.625V7.875C4.375 7.39102 4.76602 7 5.25 7H8.75V5.30195C8.75 4.79062 9.16562 4.375 9.67695 4.375C9.92305 4.375 10.1582 4.47344 10.3332 4.6457ZM4.375 4.375H2.625C2.14102 4.375 1.75 4.76602 1.75 5.25V12.25C1.75 12.734 2.14102 13.125 2.625 13.125H4.375C4.85898 13.125 5.25 13.516 5.25 14C5.25 14.484 4.85898 14.875 4.375 14.875H2.625C1.17578 14.875 0 13.6992 0 12.25V5.25C0 3.80078 1.17578 2.625 2.625 2.625H4.375C4.85898 2.625 5.25 3.01602 5.25 3.5C5.25 3.98398 4.85898 4.375 4.375 4.375Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.91cde16d604df6fdc994b30e0c1ec566.svg";
export { ForwardRef as ReactComponent };